import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './EduLicenseMessage.css';
const cx = classNames.bind(styles);

class EduLicenseMessage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    // 라이센스 결과
    let licenseContent;
    const { licenseResult } = this.props;
    const licenseResultData = {
      // 양호한 라이센스
      valid: [],
      // 라이센스 없음
      invalid: []
    };
    // 라이센스 없을때
    const noLicense = licenseResult.error && licenseResult.error === 'noLicense' ? true : false;
    // 교육 시작일이 라이센스 종료일보다 이 후 일때
    const noReserve = licenseResult.error && licenseResult.error === 'noReserve' ? true : false;
    let periodCnt = 0;
    let timesCnt = 0;

    if (!licenseResult.isValidLicense) {
      if (!!licenseResult && licenseResult.list && licenseResult.list.length > 0) {
        for (let i = 0, l = licenseResult.list.length; i < l; i++) {
          const dd = licenseResult.list[i];
          if (dd.licenseType === 1 || dd.licenseType === 2) {
            periodCnt += 1;
          }
          if (dd.licenseType === 4) {
            timesCnt += 1;
          }

          licenseResultData.invalid.push(
            <div>
              {/* 기간 */}
              {(dd.licenseType === 1 || dd.licenseType === 2) && (
                <div className={cx('licensePeriod')}>
                  {periodCnt === 1 && (
                    <div className={cx('license-name')}>
                      · {defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' })) + ' '}
                      {licenseResult.periodCnt > 0 && (
                        <b>
                          {'(' +
                            licenseResult.periodCnt +
                            defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' })) +
                            ' ' +
                            defineMessages(formatMessage({ id: 'LicenseList_29', defaultMessage: '부족' })) +
                            ')'}
                        </b>
                      )}
                    </div>
                  )}
                  <div className={cx('licenseRow')}>
                    <div className={cx('license-number')}>#{dd.licenseNo}</div>
                    <div className={cx('license-target')}>
                      {dd.licenseCount - dd.remainCount} /{' '}
                      {dd.licenseCount + defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
                    </div>
                    <div>
                      {common.timeFormatFromUTCEpoch(dd.startEpoch, 3) +
                        '~' +
                        common.timeFormatFromUTCEpoch(dd.endEpoch, 3)}
                    </div>
                  </div>
                </div>
              )}
              {/* 횟수 */}
              {dd.licenseType === 4 && (
                <div className={cx('licenseTimes')}>
                  {timesCnt === 1 && (
                    <div className={cx('license-name')}>
                      · {defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' })) + ' '}
                      {licenseResult.timesCnt > 0 && (
                        <b>
                          {'(' +
                            licenseResult.timesCnt +
                            defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' })) +
                            ' ' +
                            defineMessages(formatMessage({ id: 'LicenseList_29', defaultMessage: '부족' })) +
                            ')'}
                        </b>
                      )}
                    </div>
                  )}
                  <div className={cx('licenseRow')}>
                    <div className={cx('license-number')}>#{dd.licenseNo}</div>
                    <div className={cx('license-target')}>
                      {dd.licenseCount + defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))}
                    </div>
                    <div className={cx('')}>
                      {dd.examLimitCount -
                        dd.remainCount +
                        ' / ' +
                        dd.examLimitCount +
                        defineMessages(formatMessage({ id: 'StartExamWizardContent_107', defaultMessage: '회' }))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        }
      }

      if (licenseResultData.invalid.length > 0 || !!noLicense || !!noReserve) {
        licenseContent = (
          <div className={cx('license-error-message')}>
            <div className={cx('startExam-licenseError-area', 'edu-licenseError')}>
              <div className={cx('startExam-licenseError-title')}>
                {defineMessages(
                  formatMessage({
                    id: 'StartExamWizardContent_101',
                    defaultMessage: '라이센스 현황'
                  })
                )}
              </div>
              <div className={cx('startExam-licenseError-content')}>
                {!!noLicense &&
                  defineMessages(
                    formatMessage({
                      id: 'LicenseList_26',
                      defaultMessage: '라이센스가 존재하지 않습니다.'
                    })
                  )}
                {!!noReserve &&
                  defineMessages(
                    formatMessage({
                      id: 'LicenseList_32',
                      defaultMessage: '교육 시작일을 라이센스 유효기간 이후로 예약할 수 없습니다.'
                    })
                  )}
                {!noLicense &&
                  !noReserve &&
                  defineMessages(
                    formatMessage({
                      id: 'LicenseList_27',
                      defaultMessage: '라이센스의 수량이 부족합니다.'
                    })
                  )}
                {!noLicense && (
                  <div className={cx('startExam-licenseError-Detail')}>
                    {licenseResultData.invalid.map((data, index) => <div key={index}>{data}</div>)}
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      } else {
        licenseContent = (
          <div className={cx('licenseError ui error message')}>
            {defineMessages(formatMessage({ id: 'StartExamWizardContent_80', defaultMessage: '라이센스 에러' }))}
          </div>
        );
      }
    }

    return licenseContent;
  }
}

export default injectIntl(EduLicenseMessage);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduLicenseMessage.js